<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <transition
    enter-active-class="ease-out duration-300"
    enter-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="ease-in duration-200"
    leave-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="showModalCustomerAboutToExpire"
      class="fixed z-50 inset-0 overflow-y-auto"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div
        class="
          flex
          items-end
          justify-center
          min-h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:block sm:p-0
        "
      >
        <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
        ></div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >

        <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
        <div
          class="
            inline-block
            align-bottom
            bg-white
            rounded-lg
            text-left
            overflow-hidden
            shadow-xl
            transform
            transition-all
            sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full
          "
        >
          <div class="bg-white p-6 relative">
            <div>
              <div class="mb-4 text-xl font-semibold text-gray-900">
                ลูกค้าใกล้หมดอายุใช้งาน
              </div>

              <button
                @click="onClose"
                aria-label="Close panel"
                class="
                  text-gray-400
                  hover:text-gray-600
                  transition
                  ease-in-out
                  duration-150
                  absolute
                  top-5
                  right-5
                "
              >
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>

            <div class="mt-4 flex items-center justify-between space-x-4">
              <div class="w-72">
                <SearchWidgetResultsList v-model="search" />
              </div>

              <!-- <button
                type="button"
                class="
                  inline-flex
                  items-center
                  px-4
                  py-2
                  border border-transparent
                  rounded-md
                  shadow-sm
                  text-base
                  tracking-wider
                  text-white
                  bg-cyan-600
                  hover:bg-cyan-700
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-cyan-500
                "
              >
                SEND EMAIL ALL
              </button> -->
            </div>

            <!-- Error Message -->
            <div
              v-if="errors.length > 0"
              class="mt-2 px-4 py-3 bg-red-600 bg-opacity-20 flex items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-red-600"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <p class="text-base font-semibold text-red-800 flex-1 px-3">
                {{ errors[0] }}
              </p>
              <button
                @click="errors = []"
                type="button"
                class="focus:outline-none"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-red-600"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clip-rule="evenodd"
                  />
                </svg>
              </button>
            </div>
            <!-- End Error Message -->

            <!-- table -->
            <div class="mt-4">
              <AppDataTable
                :isCheckbox="false"
                :options="options"
                :headers="[
                  {
                    text: 'รหัสลูกค้า',
                    class: 'text-left w-28',
                    value: 'company_code',
                  },
                  {
                    text: 'ชื่อลูกค้า (ไทย)',
                    class: 'text-left',
                    value: 'title_th',
                  },
                  {
                    text: 'เริ่มต้นใช้งาน',
                    class: 'text-left w-40',
                    value: 'activate_start_date',
                  },
                  {
                    text: 'สิ้นสุดการใช้งาน',
                    class: 'text-left w-40',
                    value: 'activate_end_date',
                  },
                  {
                    text: 'ส่งอีเมลแจ้งเตือนล่าสุด',
                    class: 'text-left w-48',
                    value: 'pre_expiration_notification_sent_at',
                  },
                  {
                    text: 'ส่งอีเมล',
                    sortable: false,
                    class: 'text-left w-40',
                    value: 'send_email',
                  },
                ]"
                :items="filterCustomers.items"
                @sort="sort"
              >
                <template v-slot:activate_start_date="{ item }">
                  {{ item.activate_start_date | formatDate }}
                </template>
                <template v-slot:activate_end_date="{ item }">
                  <div>
                    <p>{{ item.activate_end_date | formatDate }}</p>
                    <p class="text-xs font-medium text-yellow-600">
                      ({{ getDaysRemaining(item.activate_end_date) }})
                    </p>
                  </div>
                </template>
                <template v-slot:pre_expiration_notification_sent_at="{ item }">
                  <div>
                    <p>
                      {{
                        item.pre_expiration_notification_sent_at | formatDate
                      }}
                    </p>
                    <p
                      v-if="item.pre_expiration_notification_sent_at"
                      class="text-xs font-medium text-cyan-600"
                    >
                      ({{
                        getDaysAgo(item.pre_expiration_notification_sent_at)
                      }})
                    </p>
                  </div>
                </template>
                <template v-slot:send_email="{ item }">
                  <p v-if="isCanSendEmail(item)" class="text-sm text-cyan-600">
                    ส่งอีเมลแล้ว
                  </p>
                  <button
                    v-else
                    @click="handleSendEmail(item)"
                    :disabled="loading"
                    :class="{ 'cursor-not-allowed': loading }"
                    type="button"
                    class="
                      border
                      px-2
                      py-1
                      rounded-md
                      text-sm text-gray-600
                      hover:text-gray-900
                    "
                  >
                    <div class="flex items-center">
                      <svg
                        v-if="loading"
                        class="animate-spin -ml-1 mr-3 h-5 w-5 text-cyan-700"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          class="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          class="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      <span> SEND EMAIL </span>
                    </div>
                  </button>
                </template>
              </AppDataTable>
            </div>
            <!-- end table -->

            <!-- pagination -->
            <div class="py-4 flex items-center justify-start">
              <AppPagination
                :options="options"
                :startNumberItem="startNumberItem"
                :endNumberItem="endNumberItem"
                :totalItems="filterCustomers.total"
                :isPrevPage="isPrevPage"
                :isNextPage="isNextPage"
                @decreasePage="() => options.page--"
                @increasePage="() => options.page++"
                @itemsPerPageChange="() => (options.page = 1)"
              />
            </div>
            <!-- end pagination -->
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import AppDataTable from '@/components/AppDataTable'
import AppPagination from '@/components/AppPagination'
import SearchWidgetResultsList from '@/components/SearchWidgetResultsList'
import moment from 'moment'

export default {
  components: {
    AppDataTable,
    AppPagination,
    SearchWidgetResultsList,
  },

  data() {
    return {
      loading: false,
      errors: [],
      search: '',
      options: {
        sortBy: 'company_code',
        sortDesc: false,
        itemsPerPage: 10,
        page: 1,
      },
    }
  },

  filters: {
    formatDate: function (value) {
      return value ? moment(String(value)).format('DD/MM/YYYY') : '-'
    },
  },

  watch: {
    search() {
      this.options.page = 1
    },
    filterCustomers(val) {
      if (val.total === 0 && this.showModalCustomerAboutToExpire) {
        this.onClose()
      }
    },
  },

  computed: {
    isCanSendEmail() {
      return (item) => {
        if (!item.pre_expiration_notification_sent_at) {
          return false // ยังไม่เคยส่ง → ส่งได้
        }

        const today = moment().startOf('day')
        const expiryDate = moment(item.activate_end_date).startOf('day')
        const sentAt = moment(item.pre_expiration_notification_sent_at).startOf(
          'day'
        )

        const daysUntilExpiry = expiryDate.diff(today, 'days')

        // เหลือมากกว่า 7 วัน → ส่งไปแล้ว ไม่สามารถส่งได้อีก
        if (daysUntilExpiry > 7) {
          return true
        }

        // เหลือ 7 วันหรือน้อยกว่า → ส่งได้วันละ 1 ครั้ง (ต้องเป็นคนละวัน)
        const daysSinceSent = today.diff(sentAt, 'days')
        return daysSinceSent < 1
      }
    },

    showModalCustomerAboutToExpire() {
      return this.$store.state.showModalCustomerAboutToExpire
    },

    customers() {
      return this.$store.state.customer.customers
    },

    filterCustomers() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let items = this.customers

      items = items
        .filter(
          (e) =>
            e.activate_end_date >= moment.utc(new Date()).format('YYYY-MM-DD')
        )
        .filter(
          (e) =>
            e.activate_end_date <=
            moment.utc(new Date()).add(1, 'M').format('YYYY-MM-DD')
        )
        .filter((e) => !this.isCanSendEmail(e))

      if (this.search) {
        items = items.filter((item) => {
          return Object.values({
            company_code: item.company_code,
            title_th: item.title_th,
            activate_start_date: item.activate_start_date
              ? moment(item.activate_start_date).format('DD/MM/YYYY')
              : '',
            activate_end_date: item.activate_end_date
              ? moment(item.activate_end_date).format('DD/MM/YYYY')
              : '',
          }).some((s) =>
            s.toString().toLowerCase().includes(this.search.toLowerCase())
          )
        })
      }

      items = items.sort((a, b) => {
        const sortA = a[sortBy] || ''
        const sortB = b[sortBy] || ''

        if (sortDesc) {
          if (sortA < sortB) return 1
          if (sortA > sortB) return -1
          return 0
        } else {
          if (sortA < sortB) return -1
          if (sortA > sortB) return 1
          return 0
        }
      })

      const total = items.length

      if (itemsPerPage > 0) {
        items = items.slice((page - 1) * itemsPerPage, page * itemsPerPage)
      }

      return { items, total }
    },

    startNumberItem() {
      if (this.filterCustomers.total === 0) return 0

      return (this.options.page - 1) * this.options.itemsPerPage + 1
    },

    endNumberItem() {
      const sum = this.options.page * this.options.itemsPerPage
      if (sum < this.filterCustomers.total) return sum

      return this.filterCustomers.total
    },

    isPrevPage() {
      if (this.options.page === 1) return true

      return false
    },

    isNextPage() {
      if (this.filterCustomers.length === 0) return true

      return (
        this.options.page ===
        Math.ceil(this.filterCustomers.total / this.options.itemsPerPage)
      )
    },
  },

  methods: {
    getDaysAgo(date) {
      if (!date) return ''
      // Use startOf('day') for both dates to avoid timezone/time issues
      const today = moment().startOf('day')
      const inputDate = moment(date).startOf('day')
      const days = today.diff(inputDate, 'days')
      if (days === 0) return 'วันนี้'
      if (days >= 1) return `${days} วันที่แล้ว`
      return ''
    },

    getDaysRemaining(date) {
      if (!date) return ''

      // สร้าง moment object สำหรับวันหมดอายุ ตั้งเวลาเป็น 23:59:59
      const expiryDate = moment(date).endOf('day')
      const now = moment()

      const days = expiryDate.diff(now, 'days')

      if (days === 0) {
        return 'สิ้นสุดวันนี้'
      }

      return `เหลืออีก ${days} วัน`
    },

    async handleSendEmail(item) {
      try {
        this.loading = true
        await this.$store.dispatch('customer/sendEmailToCompanyAboutToExpire', {
          company_uuid: item.company_uuid,
          body: {},
        })

        await this.$store.dispatch('customer/fetchCustomers')
      } catch (error) {
        if (error.response && error.response.data) {
          this.errors.push(
            error.response.data.message || 'Something went wrong.'
          )
        }

        console.error('Error sending email:', error)
      } finally {
        this.loading = false
      }
    },

    onClose() {
      this.$store.commit('setShowModalCustomerAboutToExpire', false)
    },

    sort(value) {
      if (this.options.sortBy === value) {
        this.options.sortDesc = !this.options.sortDesc
        this.options.page = 1
      } else {
        this.options.sortBy = value
        this.options.sortDesc = false
        this.options.page = 1
      }
    },
  },
}
</script>
